// libs
import React, { memo, useState } from 'react';
import isEmpty from 'lodash/isEmpty';

// components
import Tag from './components/Tag';

// styles
import { Container, Title, TagsContainer } from './styles';

// defs
import { ResponsibltTagWidget } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/components/ResponsibleTags/types';
interface ResponsibleTagsProps {
  className?: string;
  widget: ResponsibltTagWidget;
}

function ResponsibleTagsV2({ className, widget }: ResponsibleTagsProps) {
  const [animationIndex, setAnimationIndex] = useState(1);

  const onTagAnimationEnd = (index: number) => {
    setAnimationIndex(index + 1);
  };

  const handleIndexManipulations = (visibleIndex: number) => {
    if (visibleIndex > 3) {
      setAnimationIndex(Math.max(animationIndex, visibleIndex));
    }
  };

  if (isEmpty(widget)) return null;
  return (
    <Container className={className}>
      <Title>{widget.title}</Title>
      <TagsContainer data-test="container-test">
        {widget.tags.map((tag, i: number) => {
          return (
            <Tag
              tagInfo={tag}
              key={i}
              index={i}
              showAnimation={i < animationIndex}
              onAnimationEnd={() => onTagAnimationEnd(i + 1)}
              setAnimationIndex={handleIndexManipulations}
            ></Tag>
          );
        })}
      </TagsContainer>
    </Container>
  );
}

export default memo(ResponsibleTagsV2);
